// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --three-bg-light: rgb(234, 234, 234);
  --three-bg-dark: rgb(8, 8, 8);
}

.MyThree {
  z-index: -1;
  position: fixed;
  top: 0;
  left: 0;
  transition: opacity 0.5s ease-in-out;
}

.fade {
  opacity: 0;
  transition: all 0.5s ease-in-out;
  display: none;
  /* Ensure the element is hidden initially */
}

.fade.show {
  opacity: 1;
  display: block;
  /* Show the element */
}

/* Styles for loader and notifications */
.modal_container {
  display: none;
  /* Hidden by default */
  position: fixed;
  /* Stay in place */
  z-index: 100;
  /* Sit on top */
  padding-top: 50vh;
  /* Location of the box */
  left: 0;
  top: 0;
  width: 100vw;
  /* Full width */
  height: 100vh;
  /* Full height */
  overflow: auto;
  /* Enable scroll if needed */
  background-color: rgb(0, 0, 0);
  /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4);
  /* Black w/ opacity */
}

.modal-content {
  background-color: rgba(254, 254, 254, 0);
  margin: auto;
  padding: 20px;
  width: 50%;
  text-align: center;
  user-select: none;
}

.loader {
  width: 100%;
  height: 15px;
  text-align: center;
}

.dot {
  position: relative;
  width: 15px;
  height: 15px;
  margin: 0 2px;
  display: inline-block;
}

.dot:first-child:before {
  animation-delay: 0ms;
}

.dot:first-child:after {
  animation-delay: 0ms;
}

.dot:last-child:before {
  animation-delay: 200ms;
}

.dot:last-child:after {
  animation-delay: 200ms;
}

.dot:before {
  content: "";
  position: absolute;
  left: 0;
  width: 15px;
  height: 15px;
  background-color: blue;
  animation-name: dotHover;
  animation-duration: 900ms;
  animation-timing-function: cubic-bezier(0.82, 0, 0.26, 1);
  animation-iteration-count: infinite;
  animation-delay: 100ms;
  background: white;
  border-radius: 100%;
}

.dot:after {
  content: "";
  position: absolute;
  z-index: -1;
  background: black;
  box-shadow: 0px 0px 1px black;
  opacity: 0.2;
  width: 100%;
  height: 3px;
  left: 0;
  bottom: -2px;
  border-radius: 100%;
  animation-name: dotShadow;
  animation-duration: 900ms;
  animation-timing-function: cubic-bezier(0.82, 0, 0.26, 1);
  animation-iteration-count: infinite;
  animation-delay: 100ms;
}

@keyframes dotShadow {
  0% {
    transform: scaleX(1);
  }
  50% {
    opacity: 0;
    transform: scaleX(0.6);
  }
  100% {
    transform: scaleX(1);
  }
}
@keyframes dotHover {
  0% {
    top: 0px;
  }
  50% {
    top: -50px;
    transform: scale(1.1);
  }
  100% {
    top: 0;
  }
}
div.tp-dfwv {
  width: 90vw;
  top: 60%;
  left: 50%;
  transform: translateX(-50%);
}
@supports (-webkit-touch-callout: none) {
  div.tp-dfwv {
    /* CSS specific to iOS devices */
    position: fixed;
  }
}
@supports not (-webkit-touch-callout: none) {
  div.tp-dfwv {
    /* CSS for other than iOS devices */
    position: absolute;
  }
}

div.tp-tabv_c {
  overflow: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(40, 40, 40, 0.5) rgba(40, 41, 46, 0.1);
  max-height: 20vh;
}

div.tp-tabv_c::-webkit-scrollbar {
  width: 12px;
  /* width of the entire scrollbar */
}

div.tp-tabv_c::-webkit-scrollbar-track {
  background: rgba(40, 41, 46, 0.1);
  /* color of the tracking area */
}

div.tp-tabv_c::-webkit-scrollbar-thumb {
  background-color: rgba(40, 40, 40, 0.5);
  /* color of the scroll thumb */
  border-radius: 20px;
  /* roundness of the scroll thumb */
  border: 3px solid rgba(40, 41, 46, 0.1);
  /* creates padding around scroll thumb */
}

div.tp-rotv {
  font-size: 1em;
  backdrop-filter: blur(4px);
}

div.tp-btngridv {
  display: inline-grid;
  gap: 0.5em;
  justify-self: center;
}

div.tp-fldv_m {
  display: none;
}

div.btn-icon-style {
  padding: 0 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* div.tp-btnv_t {
    font-weight: normal;
    font-family: "Font Awesome 6 Free Solid";
  } */
/* div.tp-btnv {
    width: 25%;
  } */`, "",{"version":3,"sources":["webpack://./src/components/MyThree.scss"],"names":[],"mappings":"AAAA;EACI,oCAAA;EACA,6BAAA;AACJ;;AAEA;EACI,WAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,oCAAA;AACJ;;AAEA;EACI,UAAA;EACA,gCAAA;EACA,aAAA;EACA,2CAAA;AACJ;;AAEA;EACI,UAAA;EACA,cAAA;EACA,qBAAA;AACJ;;AAEA,wCAAA;AAEA;EACI,aAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,4BAAA;EACA,8BAAA;EACA,mBAAA;EACA,oCAAA;EACA,qBAAA;AAAJ;;AAGA;EACI,wCAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;AAAJ;;AAGA;EACI,oBAAA;AAAJ;;AAGA;EACI,oBAAA;AAAJ;;AAGA;EACI,sBAAA;AAAJ;;AAGA;EACI,sBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,wBAAA;EACA,yBAAA;EACA,yDAAA;EACA,mCAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,6BAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,OAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yDAAA;EACA,mCAAA;EACA,sBAAA;AAAJ;;AAGA;EACI;IACI,oBAAA;EAAN;EAGE;IACI,UAAA;IACA,sBAAA;EADN;EAIE;IACI,oBAAA;EAFN;AACF;AAKA;EACI;IACI,QAAA;EAHN;EAME;IACI,UAAA;IACA,qBAAA;EAJN;EAOE;IACI,MAAA;EALN;AACF;AAQA;EACI,WAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;AANJ;AAQI;EANJ;IAOQ,gCAAA;IACA,eAAA;EALN;AACF;AAOM;EAXN;IAYQ,mCAAA;IACA,kBAAA;EAJN;AACF;;AAOA;EACI,cAAA;EACA,qBAAA;EACA,4DAAA;EACA,gBAAA;AAJJ;;AAOA;EACI,WAAA;EACA,kCAAA;AAJJ;;AAOA;EACI,iCAAA;EACA,+BAAA;AAJJ;;AAOA;EACI,uCAAA;EACA,8BAAA;EACA,mBAAA;EACA,kCAAA;EACA,uCAAA;EACA,wCAAA;AAJJ;;AAOA;EACI,cAAA;EACA,0BAAA;AAJJ;;AAOA;EACI,oBAAA;EACA,UAAA;EACA,oBAAA;AAJJ;;AAOA;EACI,aAAA;AAJJ;;AAaA;EACI,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAVJ;;AAaA;;;KAAA;AAKA;;KAAA","sourcesContent":[":root {\n    --three-bg-light: rgb(234, 234, 234);\n    --three-bg-dark: rgb(8, 8, 8);\n}\n\n.MyThree {\n    z-index: -1;\n    position: fixed;\n    top: 0;\n    left: 0;\n    transition: opacity 0.5s ease-in-out;\n}\n\n.fade {\n    opacity: 0;\n    transition: all 0.5s ease-in-out;\n    display: none;\n    /* Ensure the element is hidden initially */\n}\n\n.fade.show {\n    opacity: 1;\n    display: block;\n    /* Show the element */\n}\n\n/* Styles for loader and notifications */\n\n.modal_container {\n    display: none;\n    /* Hidden by default */\n    position: fixed;\n    /* Stay in place */\n    z-index: 100;\n    /* Sit on top */\n    padding-top: 50vh;\n    /* Location of the box */\n    left: 0;\n    top: 0;\n    width: 100vw;\n    /* Full width */\n    height: 100vh;\n    /* Full height */\n    overflow: auto;\n    /* Enable scroll if needed */\n    background-color: rgb(0, 0, 0);\n    /* Fallback color */\n    background-color: rgba(0, 0, 0, 0.4);\n    /* Black w/ opacity */\n}\n\n.modal-content {\n    background-color: #fefefe00;\n    margin: auto;\n    padding: 20px;\n    width: 50%;\n    text-align: center;\n    user-select: none;\n}\n\n.loader {\n    width: 100%;\n    height: 15px;\n    text-align: center;\n}\n\n.dot {\n    position: relative;\n    width: 15px;\n    height: 15px;\n    margin: 0 2px;\n    display: inline-block;\n}\n\n.dot:first-child:before {\n    animation-delay: 0ms;\n}\n\n.dot:first-child:after {\n    animation-delay: 0ms;\n}\n\n.dot:last-child:before {\n    animation-delay: 200ms;\n}\n\n.dot:last-child:after {\n    animation-delay: 200ms;\n}\n\n.dot:before {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    width: 15px;\n    height: 15px;\n    background-color: blue;\n    animation-name: dotHover;\n    animation-duration: 900ms;\n    animation-timing-function: cubic-bezier(.82, 0, .26, 1);\n    animation-iteration-count: infinite;\n    animation-delay: 100ms;\n    background: white;\n    border-radius: 100%;\n}\n\n.dot:after {\n    content: \"\";\n    position: absolute;\n    z-index: -1;\n    background: black;\n    box-shadow: 0px 0px 1px black;\n    opacity: .20;\n    width: 100%;\n    height: 3px;\n    left: 0;\n    bottom: -2px;\n    border-radius: 100%;\n    animation-name: dotShadow;\n    animation-duration: 900ms;\n    animation-timing-function: cubic-bezier(.82, 0, .26, 1);\n    animation-iteration-count: infinite;\n    animation-delay: 100ms;\n}\n\n@keyframes dotShadow {\n    0% {\n        transform: scaleX(1);\n    }\n\n    50% {\n        opacity: 0;\n        transform: scaleX(.6);\n    }\n\n    100% {\n        transform: scaleX(1);\n    }\n}\n\n@keyframes dotHover {\n    0% {\n        top: 0px;\n    }\n\n    50% {\n        top: -50px;\n        transform: scale(1.1);\n    }\n\n    100% {\n        top: 0;\n    }\n}\n\ndiv.tp-dfwv {\n    width: 90vw;\n    top: 60%;\n    left: 50%;\n    transform: translateX(-50%);\n\n    @supports (-webkit-touch-callout: none) {\n        /* CSS specific to iOS devices */ \n        position: fixed;\n    }\n      \n      @supports not (-webkit-touch-callout: none) {\n        /* CSS for other than iOS devices */ \n        position: absolute;\n    }\n}\n\ndiv.tp-tabv_c {\n    overflow: auto;\n    scrollbar-width: thin;\n    scrollbar-color: rgb(40, 40, 40, 0.5) rgba(40, 41, 46, 0.1);\n    max-height: 20vh;\n}\n\ndiv.tp-tabv_c::-webkit-scrollbar {\n    width: 12px;\n    /* width of the entire scrollbar */\n}\n\ndiv.tp-tabv_c::-webkit-scrollbar-track {\n    background: rgba(40, 41, 46, 0.1);\n    /* color of the tracking area */\n}\n\ndiv.tp-tabv_c::-webkit-scrollbar-thumb {\n    background-color: rgb(40, 40, 40, 0.5);\n    /* color of the scroll thumb */\n    border-radius: 20px;\n    /* roundness of the scroll thumb */\n    border: 3px solid rgba(40, 41, 46, 0.1);\n    /* creates padding around scroll thumb */\n}\n\ndiv.tp-rotv {\n    font-size: 1em;\n    backdrop-filter: blur(4px);\n}\n\ndiv.tp-btngridv {\n    display: inline-grid;\n    gap: 0.5em;\n    justify-self: center;\n}\n\ndiv.tp-fldv_m {\n    display: none;\n}\n\n// Re-introduce this change if we can find a better way to\n// display the current length of the animation\n// div.tp-sldtxtv_t#seek {\n//     display: none;\n// }\n\ndiv.btn-icon-style {\n    padding: 0 .5rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n/* div.tp-btnv_t {\n    font-weight: normal;\n    font-family: \"Font Awesome 6 Free Solid\";\n  } */\n\n/* div.tp-btnv {\n    width: 25%;\n  } */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
